import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subCategoryServices } from '../services/sub-category.service';

export const useDeleteSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: subCategoryServices.softDeleteSubCategory,
    onSuccess: () => {
      queryClient.invalidateQueries(['sub-categories']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete sub category');
    },
  });
};
